module.exports = __webpack_public_path__ + "img/selected1-min.7f005fae.png";